import axios from './axios-instance';

export default {
  // getUserInfo: () => {
  //   return axios.get('/user/');
  // },
  getUserInfo: () => {
    return axios.get('/api/treasurer/seller/info');
  },

  saveUserInfo: (description, instagram, naverBlog) => {
    return axios.post('/api/treasurer/seller/info/save', {description, instagram, naverBlog});
  },
};
